/**
 * Agent Pages -- Data Sources
 *
 * Wraps the KnowledgeTab scoped to the current chatbot.
 */

import React from 'react'
import { useAgentContext } from '../../../components/layout/AgentContextLayout'
import { KnowledgeTab } from '../AgentHubTabs/KnowledgeTab'

export const DataSourcesPage: React.FC = () => {
  const { chatbot } = useAgentContext()

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold tracking-tight text-foreground">Data Sources</h1>
      <KnowledgeTab chatbot={chatbot} />
    </div>
  )
}
